import { Container, Hero, Button, Testimonials } from '@/components'
import styles from './Services.module.css'

const Services = () => {
  const services = [
    {
      id: 1,
      title: "Concrete Driveways",
      description: "Concrete driveways are strong, durable, and require little maintenance. If you're in need of a new driveway or an addition to an existing one, look no further! H&W Concrete's team of professionals can excavate, prepare forms, pour concrete, and finish the surface quickly so you can get back to your routine. There are also many decorative options to customize the look and finish of your driveway."
    },
    {
      id: 2,
      title: "Pool Decks, Porches, & Patios",
      description: "One of the biggest trends in outdoor design today is creating a safe and functional area surrounding your pool for sunbathing and barbecuing. We can provide you with several options to create an outdoor living space that's designed and built to last decades to enjoy with your family and guests."
    },
    {
      id: 3,
      title: "Sidewalks & Walkways",
      description: "Concrete walkways or sidewalks are more than just a way to get from point-A to point-B—they can add character and curb appeal to your home or business for a reasonable price. We can also customize your installation with decorative options to take the finish to the next level!"
    },
    {
      id: 4,
      title: "Garage Slabs & Pads",
      description: "Concrete slabs are used to support everything from patio furniture and homes to RV's and boats. This type of work requires efficient planning to prevent undesired results. Our crew knows proper timing, how to use the right finishing tools, and techniques to ensure a high-quality concrete slab is created every time."
    },
    {
      id: 5,
      title: "Custom Concrete Work",
      description: "Our team is experienced with a variety of concrete applications. We pride ourselves on delivering unrivaled results and providing you with technical and creative expertise to take your home or building projects to the next level. Guaranteed!"
    },
    {
      id: 6,
      title: "Demolition & More!",
      description: "Our services cover more than just concrete work so contact us today to speak with one of our helpful professionals to discuss your upcoming projects. We are well connected in Brevard County and if we find your proposal to be out of our scope of work we are more than willing to refer you to someone who can fulfill your needs."
    }
  ]

  return (
    <>
      {/* Hero Section */}
      <Hero
        title="H&W Concrete provides our customers with a wide range of services."
        subtitle="Contact us, and we'll find the best solution for your needs."
        backgroundImage="./img/hero4.png"
      >
        <Button href="/gallery" variant="primary" size="lg">
          See Our Projects
        </Button>
        <Button href="/contact" variant="secondary" size="lg">
          Contact Us
        </Button>
      </Hero>

      {/* Services Section */}
      <section className={styles.servicesSection}>
        <Container>
          <div className={styles.servicesHeader}>
            <h2 className={styles.servicesTitle}>Concrete Services</h2>
            <p className={styles.servicesDescription}>
              Our services are flexible and can fulfill the needs of any size project, whether residential or commercial. 
              Our experienced and skilled crew works hard to provide you with a wide range of options to maximize the value 
              of your time and budget.
            </p>
          </div>
        </Container>
        <Container>
          <div className={styles.servicesContent}>
            <div className={styles.servicesGrid}>
              {services.map((service) => (
                <div key={service.id} className={styles.serviceItem}>
                  <h5 className={styles.serviceTitle}>{service.title}</h5>
                  <p className={styles.serviceDescription}>{service.description}</p>
                </div>
              ))}
            </div>
          </div>
        </Container>
      </section>

      {/* Testimonials Section */}
      <Testimonials />
    </>
  )
}

export default Services 